import React from 'react'

import { Box } from '@mui/system'
import { Typography } from '@mui/material'
import { convertToPersianNumber } from 'utils'

export const CategoryCard = ({ Icon, title, link, activeCoursesCount, ...props }) => {
    return (
        <Box sx={{ display: 'flex', flexDirection: { lg: 'column' }, justifyContent: 'center', alignContent: { xs: 'center', lg: 'flex-start' }, px: 2, py: 3, background: 'white', color: 'black', minWidth: {lg:'175px'}, height: {xs:'50px' ,lg: '90px' }, borderRadius: 1 }} component={'a'} href={link}>

            <Box sx={{ display: 'flex', mb: { lg: 3 },alignItems:'center' }}>
                <Box sx={{ width: { xs: '35px', lg: '44px' }, height: { xs: '35px', lg: '44px' }, borderRadius: '50%', backgroundColor: 'rgba(185, 235, 238, 0.42)', marginRight: '-25px' }}></Box>
                <Icon sx={{ width: { xs: '30px', lg: '44px' }, height: { xs: '30px', lg: '44px' } }} />
            </Box>

            <Box sx={{
                display: 'flex',
                flexDirection: { xs: 'column', lg: 'row' },
                justifyContent: { xs: 'center', lg: 'space-between' },
                alignItems: 'center',
                ml: { xs: 2, lg: 0 }
            }}>
                <Typography color='CaptionText' fontWeight={'700'} fontSize={15}>{title}</Typography>
                {/* <Typography sx={{ marginLeft: 1, display: { xs: 'none', lg: 'block' } }} fontSize={{ xs: 10, lg: 13 }} color='GrayText'>{convertToPersianNumber(activeCoursesCount)} دوره</Typography> */}

            </Box>

        </Box>
    )
}
